module.exports = __webpack_public_path__ + "static/img/IMG_20160821_195549.50cd3fd3.jpg";